import {TimelineMax, TweenLite} from 'gsap';
import {mapState} from 'vuex';
const SplitText = require('../../../../viscomjs/utils/SplitText');

export default {
    name: 'location-viewport',
    props: {
        title: String,
        className: String
    },
    computed: {
        ...mapState('quiz', {
            totalScore: state => state.totalScore,
            numQuestions: state => state.numQuestions,
            questionIndex: state => {
                return state.currentQuestion + 1;
            }
        }),
        visibility() {
            return this.entered;
        }
    },
    data() {
        return {
            entered: false,
            transitionName: 'in',
            realTitle: '',
            ttlVisible: '',
            stateVisible: ''
        };
    },
    mounted() {
        this.setTtl();

        this.entered = true;
    },
    watch: {
        visibility(to) {
            if (to) this.show();
            else this.hide();
        },
        title() {
            this.setTtlInvisible();
            TweenLite.delayedCall(0.46, this.setTtl, [], this);
        },
        realTitle() {
            TweenLite.delayedCall(0.001, this.prepareTitle, [], this);
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.transitionName = 'in';
            vm.entered = true;
        });
    },
    beforeRouteUpdate(to, from, next) {
        if (to.params.index === from.params.index) {
            next();
            return;
        }
        this.restart();
        next();
    },
    beforeRouteLeave(to, from, next) {
        this.transitionName = 'out';
        this.entered = false;
        this.hide();
        TweenLite.delayedCall(0.5, next);
    },
    template: require('../../../../../../components/templates/location-viewport.pug'),
    methods: {
        show() {
            const tl = new TimelineMax();
            tl.addLabel('st');
            tl.call(this.setTtlVisible, [], this, 'st+=' + 0.5);
            tl.call(this.setStateVisible, [], this, 'st+=' + 0.5);
        },
        hide() {
            const tl = new TimelineMax();
            tl.addLabel('st');
            tl.call(this.setTtlInvisible, [], this, 'st+=' + 0.15);
            tl.call(this.setStateInvisible, [], this, 'st+=' + 0.15);
        },
        setTtl() {
            this.realTitle = this.title;
        },
        setTtlVisible() {
            this.ttlVisible = 'active';
        },
        setTtlInvisible() {
            this.ttlVisible = '';
        },
        setStateVisible() {
            this.stateVisible = 'active';
        },
        setStateInvisible() {
            this.stateVisible = '';
        },
        start() {
            this.transitionName = 'in';
            this.entered = true;
            TweenLite.killDelayedCallsTo(this.start);
        },
        restart() {
            this.transitionName = 'in-reset';
            this.entered = false;
            TweenLite.killDelayedCallsTo(this.start);
            TweenLite.delayedCall(0.001, this.start, [], this);
        },
        prepareTitle() {
            SplitText.wrapSymbols([this.$el.querySelector('.location-viewport__ttl')], {
                cssProperty: 'transition',
                reverse: true,
                factor: 2,
                durationRatio: 0.7,
                durationMax: 1.15,
                durationMin: 0.95,
                nestingNum: 2,
                timingNestingLevel: 1
            });
        }
    }
};
